import { TokenMessengerMinter } from '@src/chains/solana/types/token_messenger_minter'
import { TristeroExchange } from '@src/chains/solana/types/tristero_exchange'

export const IDL: TokenMessengerMinter = {
    version: '0.1.0',
    name: 'token_messenger_minter',
    instructions: [
        {
            name: 'initialize',
            accounts: [
                {
                    name: 'payer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'upgradeAuthority',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'authorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMessenger',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenMinter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenMessengerMinterProgramData',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMessengerMinterProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'InitializeParams',
                    },
                },
            ],
        },
        {
            name: 'transferOwnership',
            accounts: [
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMessenger',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'TransferOwnershipParams',
                    },
                },
            ],
        },
        {
            name: 'acceptOwnership',
            accounts: [
                {
                    name: 'pendingOwner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMessenger',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'AcceptOwnershipParams',
                    },
                },
            ],
        },
        {
            name: 'addRemoteTokenMessenger',
            accounts: [
                {
                    name: 'payer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'remoteTokenMessenger',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'AddRemoteTokenMessengerParams',
                    },
                },
            ],
        },
        {
            name: 'removeRemoteTokenMessenger',
            accounts: [
                {
                    name: 'payee',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'remoteTokenMessenger',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'RemoveRemoteTokenMessengerParams',
                    },
                },
            ],
        },
        {
            name: 'depositForBurn',
            accounts: [
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'eventRentPayer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'senderAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'burnTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'messageTransmitter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'remoteTokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'localToken',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'burnTokenMint',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'messageSentEventData',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'messageTransmitterProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMessengerMinterProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'DepositForBurnParams',
                    },
                },
            ],
            returns: 'u64',
        },
        {
            name: 'depositForBurnWithCaller',
            accounts: [
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'eventRentPayer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'senderAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'burnTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'messageTransmitter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'remoteTokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'localToken',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'burnTokenMint',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'messageSentEventData',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'messageTransmitterProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMessengerMinterProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'DepositForBurnWithCallerParams',
                    },
                },
            ],
            returns: 'u64',
        },
        {
            name: 'replaceDepositForBurn',
            accounts: [
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'eventRentPayer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'senderAuthorityPda',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'messageTransmitter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'messageSentEventData',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'messageTransmitterProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMessengerMinterProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'ReplaceDepositForBurnParams',
                    },
                },
            ],
            returns: 'u64',
        },
        {
            name: 'handleReceiveMessage',
            accounts: [
                {
                    name: 'authorityPda',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'remoteTokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'localToken',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenPair',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'recipientTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'custodyTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'HandleReceiveMessageParams',
                    },
                },
            ],
        },
        {
            name: 'setTokenController',
            accounts: [
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMinter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'SetTokenControllerParams',
                    },
                },
            ],
        },
        {
            name: 'pause',
            accounts: [
                {
                    name: 'pauser',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'PauseParams',
                    },
                },
            ],
        },
        {
            name: 'unpause',
            accounts: [
                {
                    name: 'pauser',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'UnpauseParams',
                    },
                },
            ],
        },
        {
            name: 'updatePauser',
            accounts: [
                {
                    name: 'owner',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMessenger',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenMinter',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'UpdatePauserParams',
                    },
                },
            ],
        },
        {
            name: 'setMaxBurnAmountPerMessage',
            accounts: [
                {
                    name: 'tokenController',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'localToken',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'SetMaxBurnAmountPerMessageParams',
                    },
                },
            ],
        },
        {
            name: 'addLocalToken',
            accounts: [
                {
                    name: 'payer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'tokenController',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'localToken',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'custodyTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'localTokenMint',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'AddLocalTokenParams',
                    },
                },
            ],
        },
        {
            name: 'removeLocalToken',
            accounts: [
                {
                    name: 'payee',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'tokenController',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'localToken',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'custodyTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'RemoveLocalTokenParams',
                    },
                },
            ],
        },
        {
            name: 'linkTokenPair',
            accounts: [
                {
                    name: 'payer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'tokenController',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenPair',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'LinkTokenPairParams',
                    },
                },
            ],
        },
        {
            name: 'unlinkTokenPair',
            accounts: [
                {
                    name: 'payee',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'tokenController',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenPair',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'UninkTokenPairParams',
                    },
                },
            ],
        },
        {
            name: 'burnTokenCustody',
            accounts: [
                {
                    name: 'payee',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'tokenController',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'tokenMinter',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'localToken',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'custodyTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'custodyTokenMint',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'program',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'BurnTokenCustodyParams',
                    },
                },
            ],
        },
    ],
    accounts: [
        {
            name: 'tokenMessenger',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        type: 'publicKey',
                    },
                    {
                        name: 'pendingOwner',
                        type: 'publicKey',
                    },
                    {
                        name: 'localMessageTransmitter',
                        type: 'publicKey',
                    },
                    {
                        name: 'messageBodyVersion',
                        type: 'u32',
                    },
                    {
                        name: 'authorityBump',
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'remoteTokenMessenger',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'domain',
                        type: 'u32',
                    },
                    {
                        name: 'tokenMessenger',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'tokenMinter',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'tokenController',
                        type: 'publicKey',
                    },
                    {
                        name: 'pauser',
                        type: 'publicKey',
                    },
                    {
                        name: 'paused',
                        type: 'bool',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'tokenPair',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'remoteDomain',
                        type: 'u32',
                    },
                    {
                        name: 'remoteToken',
                        type: 'publicKey',
                    },
                    {
                        name: 'localToken',
                        type: 'publicKey',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'localToken',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'custody',
                        type: 'publicKey',
                    },
                    {
                        name: 'mint',
                        type: 'publicKey',
                    },
                    {
                        name: 'burnLimitPerMessage',
                        type: 'u64',
                    },
                    {
                        name: 'messagesSent',
                        type: 'u64',
                    },
                    {
                        name: 'messagesReceived',
                        type: 'u64',
                    },
                    {
                        name: 'amountSent',
                        type: 'u128',
                    },
                    {
                        name: 'amountReceived',
                        type: 'u128',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                    {
                        name: 'custodyBump',
                        type: 'u8',
                    },
                ],
            },
        },
    ],
    types: [
        {
            name: 'AcceptOwnershipParams',
            type: {
                kind: 'struct',
                fields: [],
            },
        },
        {
            name: 'AddRemoteTokenMessengerParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'domain',
                        type: 'u32',
                    },
                    {
                        name: 'tokenMessenger',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'DepositForBurnWithCallerParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'amount',
                        type: 'u64',
                    },
                    {
                        name: 'destinationDomain',
                        type: 'u32',
                    },
                    {
                        name: 'mintRecipient',
                        type: 'publicKey',
                    },
                    {
                        name: 'destinationCaller',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'DepositForBurnParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'amount',
                        type: 'u64',
                    },
                    {
                        name: 'destinationDomain',
                        type: 'u32',
                    },
                    {
                        name: 'mintRecipient',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'HandleReceiveMessageParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'remoteDomain',
                        type: 'u32',
                    },
                    {
                        name: 'sender',
                        type: 'publicKey',
                    },
                    {
                        name: 'messageBody',
                        type: 'bytes',
                    },
                    {
                        name: 'authorityBump',
                        type: 'u8',
                    },
                ],
            },
        },
        {
            name: 'InitializeParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'tokenController',
                        type: 'publicKey',
                    },
                    {
                        name: 'localMessageTransmitter',
                        type: 'publicKey',
                    },
                    {
                        name: 'messageBodyVersion',
                        type: 'u32',
                    },
                ],
            },
        },
        {
            name: 'RemoveRemoteTokenMessengerParams',
            type: {
                kind: 'struct',
                fields: [],
            },
        },
        {
            name: 'ReplaceDepositForBurnParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'originalMessage',
                        type: 'bytes',
                    },
                    {
                        name: 'originalAttestation',
                        type: 'bytes',
                    },
                    {
                        name: 'newDestinationCaller',
                        type: 'publicKey',
                    },
                    {
                        name: 'newMintRecipient',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'TransferOwnershipParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'newOwner',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'AddLocalTokenParams',
            type: {
                kind: 'struct',
                fields: [],
            },
        },
        {
            name: 'BurnTokenCustodyParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'amount',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'LinkTokenPairParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'localToken',
                        type: 'publicKey',
                    },
                    {
                        name: 'remoteDomain',
                        type: 'u32',
                    },
                    {
                        name: 'remoteToken',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'PauseParams',
            type: {
                kind: 'struct',
                fields: [],
            },
        },
        {
            name: 'RemoveLocalTokenParams',
            type: {
                kind: 'struct',
                fields: [],
            },
        },
        {
            name: 'SetMaxBurnAmountPerMessageParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'burnLimitPerMessage',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'SetTokenControllerParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'tokenController',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'UninkTokenPairParams',
            type: {
                kind: 'struct',
                fields: [],
            },
        },
        {
            name: 'UnpauseParams',
            type: {
                kind: 'struct',
                fields: [],
            },
        },
        {
            name: 'UpdatePauserParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'newPauser',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'TokenMinterError',
            type: {
                kind: 'enum',
                variants: [
                    {
                        name: 'InvalidAuthority',
                    },
                    {
                        name: 'InvalidTokenMinterState',
                    },
                    {
                        name: 'ProgramPaused',
                    },
                    {
                        name: 'InvalidTokenPairState',
                    },
                    {
                        name: 'InvalidLocalTokenState',
                    },
                    {
                        name: 'InvalidPauser',
                    },
                    {
                        name: 'InvalidTokenController',
                    },
                    {
                        name: 'BurnAmountExceeded',
                    },
                    {
                        name: 'InvalidAmount',
                    },
                ],
            },
        },
    ],
    events: [
        {
            name: 'OwnershipTransferStarted',
            fields: [
                {
                    name: 'previousOwner',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'newOwner',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'OwnershipTransferred',
            fields: [
                {
                    name: 'previousOwner',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'newOwner',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'DepositForBurn',
            fields: [
                {
                    name: 'nonce',
                    type: 'u64',
                    index: false,
                },
                {
                    name: 'burnToken',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'amount',
                    type: 'u64',
                    index: false,
                },
                {
                    name: 'depositor',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'mintRecipient',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'destinationDomain',
                    type: 'u32',
                    index: false,
                },
                {
                    name: 'destinationTokenMessenger',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'destinationCaller',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'MintAndWithdraw',
            fields: [
                {
                    name: 'mintRecipient',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'amount',
                    type: 'u64',
                    index: false,
                },
                {
                    name: 'mintToken',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'RemoteTokenMessengerAdded',
            fields: [
                {
                    name: 'domain',
                    type: 'u32',
                    index: false,
                },
                {
                    name: 'tokenMessenger',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'RemoteTokenMessengerRemoved',
            fields: [
                {
                    name: 'domain',
                    type: 'u32',
                    index: false,
                },
                {
                    name: 'tokenMessenger',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'SetTokenController',
            fields: [
                {
                    name: 'tokenController',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'PauserChanged',
            fields: [
                {
                    name: 'newAddress',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'SetBurnLimitPerMessage',
            fields: [
                {
                    name: 'token',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'burnLimitPerMessage',
                    type: 'u64',
                    index: false,
                },
            ],
        },
        {
            name: 'LocalTokenAdded',
            fields: [
                {
                    name: 'custody',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'mint',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'LocalTokenRemoved',
            fields: [
                {
                    name: 'custody',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'mint',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'TokenPairLinked',
            fields: [
                {
                    name: 'localToken',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'remoteDomain',
                    type: 'u32',
                    index: false,
                },
                {
                    name: 'remoteToken',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'TokenPairUnlinked',
            fields: [
                {
                    name: 'localToken',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'remoteDomain',
                    type: 'u32',
                    index: false,
                },
                {
                    name: 'remoteToken',
                    type: 'publicKey',
                    index: false,
                },
            ],
        },
        {
            name: 'Pause',
            fields: [],
        },
        {
            name: 'Unpause',
            fields: [],
        },
        {
            name: 'TokenCustodyBurned',
            fields: [
                {
                    name: 'custodyTokenAccount',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'amount',
                    type: 'u64',
                    index: false,
                },
            ],
        },
    ],
    errors: [
        {
            code: 6000,
            name: 'InvalidAuthority',
            msg: 'Invalid authority',
        },
        {
            code: 6001,
            name: 'InvalidTokenMessengerState',
            msg: 'Invalid token messenger state',
        },
        {
            code: 6002,
            name: 'InvalidTokenMessenger',
            msg: 'Invalid token messenger',
        },
        {
            code: 6003,
            name: 'InvalidOwner',
            msg: 'Invalid owner',
        },
        {
            code: 6004,
            name: 'MalformedMessage',
            msg: 'Malformed message',
        },
        {
            code: 6005,
            name: 'InvalidMessageBodyVersion',
            msg: 'Invalid message body version',
        },
        {
            code: 6006,
            name: 'InvalidAmount',
            msg: 'Invalid amount',
        },
        {
            code: 6007,
            name: 'InvalidDestinationDomain',
            msg: 'Invalid destination domain',
        },
        {
            code: 6008,
            name: 'InvalidDestinationCaller',
            msg: 'Invalid destination caller',
        },
        {
            code: 6009,
            name: 'InvalidMintRecipient',
            msg: 'Invalid mint recipient',
        },
        {
            code: 6010,
            name: 'InvalidSender',
            msg: 'Invalid sender',
        },
        {
            code: 6011,
            name: 'InvalidTokenPair',
            msg: 'Invalid token pair',
        },
        {
            code: 6012,
            name: 'InvalidTokenMint',
            msg: 'Invalid token mint',
        },
    ],
}

export const ORDER_BOOK_IDL: TristeroExchange = {
    version: '0.1.0',
    name: 'tristero',
    instructions: [
        {
            name: 'registerTristeroOapp',
            accounts: [
                {
                    name: 'payer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oapp',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'adminPanel',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'oappRegistry',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'eventAuthority',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'endpointProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'RegisterTristeroOAppParams',
                    },
                },
            ],
        },
        {
            name: 'adminPanelUpdate',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'adminPanel',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'UpdateParams',
                    },
                },
            ],
        },
        {
            name: 'createMatch',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oapp',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'adminPanel',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'order',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'sourceTokenMint',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'bondAssetMint',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'bonderBondTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'stakingAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'stakingBondAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tradeMatch',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'CreateMatchParams',
                    },
                },
            ],
        },
        {
            name: 'executeMatch',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'tokenAccount',
                    isMut: true,
                    isSigner: false,
                    docs: ["sol user's token account address"],
                },
                {
                    name: 'arbUserTokenAccount',
                    isMut: true,
                    isSigner: false,
                    docs: ["arb user's token account address"],
                },
                {
                    name: 'receipt',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'ExecuteMatchParams',
                    },
                },
            ],
        },
        {
            name: 'confirmMatch',
            accounts: [
                {
                    name: 'signer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oapp',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'order',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tradeMatch',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'stakingAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'stakingBondAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'bonderTokenAccount',
                    isMut: true,
                    isSigner: false,
                    docs: ["The maker's (bonder's) token account for receiving maker payout + bonder fee"],
                },
                {
                    name: 'bonderBondTokenAccount',
                    isMut: true,
                    isSigner: false,
                    docs: ["The bonder's bond token account (to return bond tokens)"],
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'ConfirmMatchParams',
                    },
                },
            ],
        },
        {
            name: 'startChallenge',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'tradeMatch',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'ChallengeParams',
                    },
                },
            ],
        },
        {
            name: 'finishChallenge',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oapp',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'FinishChallengeParams',
                    },
                },
            ],
        },
        {
            name: 'lzReceive',
            accounts: [
                {
                    name: 'oapp',
                    isMut: true,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'LzReceiveParams',
                    },
                },
            ],
        },
        {
            name: 'lzReceiveTypes',
            accounts: [
                {
                    name: 'oftConfig',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'messageLib',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'LzReceiveTypeParams',
                    },
                },
            ],
            returns: {
                vec: {
                    defined: 'LzAccount',
                },
            },
        },
        {
            name: 'registerConfig',
            accounts: [
                {
                    name: 'payer',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oappConfig',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'lzReceiveTypesAccounts',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'paramPubkey',
                    type: 'publicKey',
                },
            ],
        },
        {
            name: 'placeOrder',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oapp',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'adminPanel',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenMint',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'matchAccount',
                    isMut: true,
                    isSigner: false,
                    isOptional: true,
                },
                {
                    name: 'order',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'params',
                    type: {
                        defined: 'PlaceOrderParams',
                    },
                },
            ],
        },
        {
            name: 'cancelOrder',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oapp',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'adminPanel',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'order',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [],
        },
        {
            name: 'unwindMatch',
            accounts: [
                {
                    name: 'authority',
                    isMut: true,
                    isSigner: true,
                },
                {
                    name: 'oapp',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'order',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tradeMatch',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'stakingAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'stakingBondAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'userTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'bonderBondTokenAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'tokenProgram',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [],
        },
    ],
    accounts: [
        {
            name: 'AdminPanel',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'authority',
                        type: 'publicKey',
                    },
                    {
                        name: 'paymentWallet',
                        type: 'publicKey',
                    },
                    {
                        name: 'backendWallet',
                        type: 'publicKey',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                    {
                        name: 'tradeFee',
                        type: 'u64',
                    },
                    {
                        name: 'matchCount',
                        type: 'u64',
                    },
                    {
                        name: 'orderCount',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'LzReceiveTypesAccounts',
            docs: ['LzReceiveTypesAccounts includes accounts that are used in the LzReceiveTypes', 'instruction.'],
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'oftConfig',
                        type: 'publicKey',
                    },
                    {
                        name: 'messageLib',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'Order',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'orderId',
                        type: 'u64',
                    },
                    {
                        name: 'userPubkey',
                        type: 'publicKey',
                    },
                    {
                        name: 'userTokenAddr',
                        type: 'publicKey',
                    },
                    {
                        name: 'sourceTokenMint',
                        type: 'publicKey',
                    },
                    {
                        name: 'matchPubkey',
                        type: {
                            option: 'publicKey',
                        },
                    },
                    {
                        name: 'dstTokenMint',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'sourceSellAmount',
                        type: 'u64',
                    },
                    {
                        name: 'dstBuyAmount',
                        type: 'u64',
                    },
                    {
                        name: 'minSellAmount',
                        type: 'u64',
                    },
                    {
                        name: 'settled',
                        type: 'u64',
                    },
                    {
                        name: 'eid',
                        type: 'u32',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                    {
                        name: 'isValiable',
                        type: 'bool',
                    },
                    {
                        name: 'targetAddress',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'bondAssetMint',
                        type: 'publicKey',
                    },
                    {
                        name: 'bondAmount',
                        type: 'u64',
                    },
                    {
                        name: 'bondFee',
                        type: 'u16',
                    },
                ],
            },
        },
        {
            name: 'Receipt',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'maker',
                        type: 'publicKey',
                    },
                    {
                        name: 'payoutQuantity',
                        type: 'u64',
                    },
                    {
                        name: 'tokenMint',
                        type: 'publicKey',
                    },
                    {
                        name: 'receiver',
                        type: 'publicKey',
                    },
                    {
                        name: 'isValuable',
                        type: 'bool',
                    },
                ],
            },
        },
        {
            name: 'TradeMatch',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'authority',
                        type: 'publicKey',
                    },
                    {
                        name: 'userTokenAddr',
                        type: 'publicKey',
                    },
                    {
                        name: 'sourceTokenMint',
                        type: 'publicKey',
                    },
                    {
                        name: 'dstTokenMint',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'arbUserTokenAccount',
                        type: 'publicKey',
                    },
                    {
                        name: 'orderIdx',
                        type: 'u64',
                    },
                    {
                        name: 'sourceSellAmount',
                        type: 'u64',
                    },
                    {
                        name: 'dstBuyAmount',
                        type: 'u64',
                    },
                    {
                        name: 'eid',
                        type: 'u32',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                    {
                        name: 'tradeMatchId',
                        type: 'u64',
                    },
                    {
                        name: 'status',
                        type: 'u8',
                    },
                ],
            },
        },
    ],
    types: [
        {
            name: 'RegisterTristeroOAppParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'delegate',
                        type: 'publicKey',
                    },
                    {
                        name: 'adminWallet',
                        type: 'publicKey',
                    },
                    {
                        name: 'paymentWallet',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'UpdateParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'adminWallet',
                        type: 'publicKey',
                    },
                    {
                        name: 'paymentWallet',
                        type: 'publicKey',
                    },
                ],
            },
        },
        {
            name: 'LzReceiveTypeParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'srcEid',
                        type: 'u32',
                    },
                    {
                        name: 'sender',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'nonce',
                        type: 'u64',
                    },
                    {
                        name: 'guid',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'message',
                        type: 'bytes',
                    },
                    {
                        name: 'extraData',
                        type: 'bytes',
                    },
                ],
            },
        },
        {
            name: 'LzReceiveParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'srcEid',
                        type: 'u32',
                    },
                    {
                        name: 'sender',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'nonce',
                        type: 'u64',
                    },
                    {
                        name: 'guid',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'message',
                        type: 'bytes',
                    },
                    {
                        name: 'extraData',
                        type: 'bytes',
                    },
                ],
            },
        },
        {
            name: 'ConfirmMatchParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'tradeMatchId',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'CreateMatchParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'orderIdx',
                        type: 'u64',
                    },
                    {
                        name: 'srcQuantity',
                        type: 'u64',
                    },
                    {
                        name: 'dstQuantity',
                        type: 'u64',
                    },
                ],
            },
        },
        {
            name: 'ExecuteMatchParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'dstEid',
                        type: 'u32',
                    },
                    {
                        name: 'tradeMatchId',
                        type: 'u64',
                    },
                    {
                        name: 'sourceSellAmount',
                        type: 'u64',
                    },
                    {
                        name: 'sender',
                        type: {
                            array: ['u8', 20],
                        },
                    },
                ],
            },
        },
        {
            name: 'FinishChallengeParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'arbEid',
                        type: 'u32',
                    },
                    {
                        name: 'tradeMatchId',
                        type: 'u64',
                    },
                    {
                        name: 'splToken',
                        type: 'publicKey',
                    },
                    {
                        name: 'erc20token',
                        type: {
                            array: ['u8', 20],
                        },
                    },
                    {
                        name: 'receiver',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                ],
            },
        },
        {
            name: 'PlaceOrderParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'sourceSellAmount',
                        type: 'u64',
                    },
                    {
                        name: 'minSellAmount',
                        type: 'u64',
                    },
                    {
                        name: 'dstTokenMint',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'dstBuyAmount',
                        type: 'u64',
                    },
                    {
                        name: 'eid',
                        type: 'u32',
                    },
                    {
                        name: 'targetAddress',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'bondAssetMint',
                        type: 'publicKey',
                    },
                    {
                        name: 'bondAmount',
                        type: 'u64',
                    },
                    {
                        name: 'bondFee',
                        type: 'u16',
                    },
                ],
            },
        },
        {
            name: 'ChallengeParams',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'tradeMatchId',
                        type: 'u64',
                    },
                    {
                        name: 'tristeroOappBump',
                        type: 'u8',
                    },
                    {
                        name: 'receiver',
                        type: {
                            array: ['u8', 32],
                        },
                    },
                    {
                        name: 'taker',
                        type: {
                            array: ['u8', 20],
                        },
                    },
                ],
            },
        },
    ],
    events: [
        {
            name: 'MsgReceived',
            fields: [
                {
                    name: 'srcEid',
                    type: 'u32',
                    index: false,
                },
                {
                    name: 'sender',
                    type: {
                        array: ['u8', 32],
                    },
                    index: false,
                },
                {
                    name: 'nonce',
                    type: 'u64',
                    index: false,
                },
                {
                    name: 'guid',
                    type: {
                        array: ['u8', 32],
                    },
                    index: false,
                },
                {
                    name: 'message',
                    type: 'bytes',
                    index: false,
                },
                {
                    name: 'extraData',
                    type: 'bytes',
                    index: false,
                },
            ],
        },
        {
            name: 'OrderPlaced',
            fields: [
                {
                    name: 'dstLzc',
                    type: 'u32',
                    index: false,
                },
                {
                    name: 'orderIndex',
                    type: 'u64',
                    index: false,
                },
                {
                    name: 'dstTokenMint',
                    type: {
                        array: ['u8', 32],
                    },
                    index: false,
                },
                {
                    name: 'sourceTokenMint',
                    type: 'publicKey',
                    index: false,
                },
                {
                    name: 'targetAddress',
                    type: {
                        array: ['u8', 32],
                    },
                    index: false,
                },
            ],
        },
    ],
    errors: [
        {
            code: 6000,
            name: 'InvalidAuthority',
            msg: 'Invalid Authority',
        },
        {
            code: 6001,
            name: 'InvalidTokenOwner',
            msg: 'InvalidTokenOwner',
        },
        {
            code: 6002,
            name: 'InvalidTokenMintAddress',
            msg: 'InvalidTokenMintAddress',
        },
        {
            code: 6003,
            name: 'InvalidTokenAmount',
            msg: 'InvalidTokenAmount',
        },
        {
            code: 6004,
            name: 'InvalidOwnerWithTradeMatch',
            msg: 'InvalidOwnerWithTradeMatch',
        },
        {
            code: 6005,
            name: 'InvalidTradeMatch',
            msg: 'InvalidTradeMatch',
        },
        {
            code: 6006,
            name: 'InvalidTokenStandard',
            msg: 'InvalidTokenStandard',
        },
        {
            code: 6007,
            name: 'PayloadHashNotFound',
            msg: 'PayloadHashNotFound',
        },
        {
            code: 6008,
            name: 'NotAgain',
            msg: 'Already canceled or traded',
        },
        {
            code: 6009,
            name: 'NotEvenStarted',
            msg: 'Not even started',
        },
        {
            code: 6010,
            name: 'WrongMsgTypeError',
            msg: 'Wrong msg type',
        },
        {
            code: 6011,
            name: 'WrongMsgDstIndex',
            msg: 'Can not find with dst index',
        },
        {
            code: 6012,
            name: 'WrongMsgSrcToken',
            msg: 'Can not find with src token address',
        },
        {
            code: 6013,
            name: 'WrongMsgDstToken',
            msg: 'Can not find with dst token address',
        },
        {
            code: 6014,
            name: 'WrongAuthorityToCancel',
            msg: 'Can not cancel with this authority',
        },
        {
            code: 6015,
            name: 'MinSellAmountConflict',
            msg: 'Min Sell Amount Conflict',
        },
        {
            code: 6016,
            name: 'InSufficientFundsOfOrder',
            msg: 'Insufficient Funds of Order',
        },
        {
            code: 6017,
            name: 'TokenNotApproved',
            msg: 'Token Not Approved',
        },
        {
            code: 6018,
            name: 'InsufficientApproval',
            msg: 'Insufficient Approval',
        },
        {
            code: 6019,
            name: 'OrderNotValid',
            msg: 'Order Not Valid',
        },
        {
            code: 6020,
            name: 'OrderAlreadyMatched',
            msg: 'Order Already Matched',
        },
        {
            code: 6021,
            name: 'MatchAlreadyFinalized',
            msg: 'Match Already Finalized',
        },
        {
            code: 6022,
            name: 'ArithmeticError',
            msg: 'Arithmetic Error',
        },
        {
            code: 6023,
            name: 'InvalidSendLibrary',
        },
        {
            code: 6024,
            name: 'InvalidReceiveLibrary',
        },
        {
            code: 6025,
            name: 'SameValue',
        },
        {
            code: 6026,
            name: 'AccountNotFound',
        },
        {
            code: 6027,
            name: 'OnlySendLib',
        },
        {
            code: 6028,
            name: 'OnlyReceiveLib',
        },
        {
            code: 6029,
            name: 'InvalidExpiry',
        },
        {
            code: 6030,
            name: 'OnlyNonDefaultLib',
        },
        {
            code: 6031,
            name: 'InvalidAmount',
        },
        {
            code: 6032,
            name: 'InvalidNonce',
        },
        {
            code: 6033,
            name: 'Unauthorized',
        },
        {
            code: 6034,
            name: 'ComposeNotFound',
        },
        {
            code: 6035,
            name: 'InvalidPayloadHash',
        },
        {
            code: 6036,
            name: 'LzTokenUnavailable',
        },
        {
            code: 6037,
            name: 'ReadOnlyAccount',
        },
        {
            code: 6038,
            name: 'InvalidMessageLib',
        },
        {
            code: 6039,
            name: 'WritableAccountNotAllowed',
        },
    ],
}
